import { SnippetsOutlined } from '@ant-design/icons';
import React from 'react';
import { Datatype } from '../../../../expressions/datatype/Datatype';
import { getSimpleWidgetReference } from '../../../../expressions/references/builder/getSimpleWidgetReference';
import { tran } from '../../../../translations/schema/TranslationSchema';
import { IWidgetType } from '../../../IWidgetType';
import { WidgetCategory, WidgetMainType, WidgetType } from '../../../Widget';
import { ISubsectionWidget } from './ISubsectionWidget';
import { SubsectionConfigComponent } from './SubsectionConfigComponent';
import { SubsectionWidgetComponent } from './SubsectionWidgetComponent';
import { SubsectionWidgetConfigSchema } from './SubsectionWidgetConfigSchema';
import { SubsectionWidgetPreview } from './SubsectionWidgetPreview';
import { createSubsectionSchema } from './createSubsectionSchema';

export const SubsectionWidetType: IWidgetType<ISubsectionWidget> = {
  type: WidgetType.Subsection,
  mainType: WidgetMainType.Container,
  category: WidgetCategory.Advanced,
  name: 'Sottosezione',
  icon: <SnippetsOutlined />,
  hasValue: false,
  getReference: getSimpleWidgetReference(Datatype.Empty),
  formComponent: SubsectionWidgetComponent,
  createFormSchema: createSubsectionSchema,
  configComponent: SubsectionConfigComponent,
  configValidator: SubsectionWidgetConfigSchema,
  drawerWidth: '90%', // TODO da verificare
  previewComponent: SubsectionWidgetPreview,
  translationSchema: tran.widget({
    label: tran.rte(),
    placeholder: tran.string(),
  }),
  rules: [],
  configOptions: {
    removeCollapsePanel: true,
  },
};
